module.exports = __webpack_public_path__ + "img/delete.d3b4cf22.svg";